export const ENV = {
    local: 'local',
    development: 'development',
    test: 'test',
    staging: 'staging',
    prod: 'prod',
    production: 'production',
};
export const LOG_TYPE = {
    error: 'error',
    warning: 'warning',
    info: 'info',
};
